// src/dom.ts
function scrollElementIntoView(el, area = "center") {
  if (!el) {
    return;
  }
  try {
    el.scrollIntoView({ behavior: "smooth", block: area });
  } catch (e) {
    el.scrollIntoView(false);
  }
}
var $ = (selector) => document.querySelector(selector);
var $$ = (selector) => Array.from(document.querySelectorAll(selector));
var waitForElement = async (selector, timeout = 1e4) => {
  const start = Date.now();
  let el = $(selector);
  while (!el && Date.now() - start < timeout) {
    await new Promise((resolve) => setTimeout(resolve, 100));
    el = $(selector);
  }
  return el;
};

// src/string.ts
function splitStringOnTokens(input, partsSoFar = []) {
  const tokenStartIndex = input.indexOf("{{");
  if (tokenStartIndex > -1) {
    const startOfString = input.slice(0, tokenStartIndex);
    const stringRemainder = input.replace(startOfString, "");
    const token = stringRemainder.slice(0, stringRemainder.indexOf("}}") + 2);
    const restOfString = stringRemainder.replace(token, "");
    return splitStringOnTokens(restOfString, [
      ...partsSoFar,
      startOfString,
      token
    ]);
  }
  return [...partsSoFar, input];
}
function truncate(text, options) {
  const { length, omission } = options;
  if (text.length <= length) {
    return text;
  }
  return text.slice(0, length - omission.length) + omission;
}
function truncateFilename(rawFileName, truncateLength = 25) {
  const fileExtensionIndex = rawFileName.lastIndexOf(".");
  const fileName = rawFileName.slice(0, fileExtensionIndex);
  const extension = rawFileName.slice(fileExtensionIndex);
  return `${truncate(fileName, {
    length: truncateLength,
    omission: "[...]"
  })}${extension}`;
}
var keys = ["firstName", "entryCode", "friendlyPrizeName"];
function interpolateTokens(contents, searchParams) {
  return keys.reduce((acc, key) => {
    return acc.replace(
      new RegExp(`{{\\s?${key}\\s?}}`, "gi"),
      searchParams.get(key) || ""
    );
  }, contents);
}
function interpolateTokensFromObject(contents, tokens) {
  return keys.reduce((acc, key) => {
    return acc.replace(new RegExp(`{{\\s?${key}\\s?}}`, "gi"), tokens[key]);
  }, contents);
}
var interpolateTokensInElement = (element, searchParams) => {
  const contents = element.innerText;
  const interpolatedContents = interpolateTokens(contents, searchParams);
  element.innerText = interpolatedContents;
};
var stringifyUrlParameters = (obj) => {
  return Object.entries(obj).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  ).join("&");
};

// src/accessibility.ts
function shouldReduceMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// src/iframe.ts
function getBodyHeight() {
  document.body.style.overflow = "hidden";
  const t = document.createElement("div");
  t.style.cssText = "display: block; width:100%; height: 0; visibility: hidden";
  const containerEl = document.getElementById("content");
  if (!containerEl) {
    return 0;
  }
  containerEl.appendChild(t);
  const { bottom } = t.getBoundingClientRect();
  const n = window.getComputedStyle(containerEl);
  const height = Math.ceil(
    ["padding-bottom", "border-bottom-width", "margin-bottom"].reduce((acc, curr) => {
      return acc + parseFloat(n[curr]);
    }, bottom)
  );
  containerEl.removeChild(t);
  return height;
}
function postBodyHeightToParentFrame() {
  window.parent.postMessage(
    {
      type: "resize",
      frameHeight: getBodyHeight()
    },
    "*"
  );
}
function isIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
}

// src/promise.ts
var waitUntilResolvedOrTimeout = async (promise, timeout) => {
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error("Timed out"));
    }, timeout);
  });
  return Promise.race([promise, timeoutPromise]);
};
export {
  $,
  $$,
  getBodyHeight,
  interpolateTokens,
  interpolateTokensFromObject,
  interpolateTokensInElement,
  isIframe,
  postBodyHeightToParentFrame,
  scrollElementIntoView,
  shouldReduceMotion,
  splitStringOnTokens,
  stringifyUrlParameters,
  truncate,
  truncateFilename,
  waitForElement,
  waitUntilResolvedOrTimeout
};
//# sourceMappingURL=index.js.map